import { useEffect, useState } from 'react'

export function useDelay(delay = 0) {
  // possible string value
  const delayInt = +delay
  const [isVisible, setVisible] = useState(delayInt === 0)

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined

    if (delayInt > 0) {
      timer = setTimeout(() => setVisible(true), delayInt * 1000)
    } else {
      setVisible(true)
    }

    return () => {
      if (timer) {
        clearTimeout(timer)
      }
    }
  }, [delayInt])

  return isVisible
}
